import { v4 as uuidv4 } from "uuid";
import { NotebookPage } from "./note";

export const pageComponent: Component = {
  type: "omega/query-omega/component/Component",
  name: "Page",
  "app-id": "built-in-app",
  "page-id": "built-in-page",
  "component-id": "omega/query-omega/component/page/PageComponent",
};

export interface Component {
  type: "omega/query-omega/component/Component";
  name: string;
  "app-id": string;
  "page-id": string;
  "component-id": string;
}

export const newComponent = (config: { name: string; page: NotebookPage }) => {
  const { name, page } = config;
  const comp: Component = {
    type: "omega/query-omega/component/Component",
    name,
    "app-id": page["app-id"],
    "page-id": page["page-id"],
    "component-id": uuidv4(),
  };
  return comp;
};

export type ComponentMap = { [k: string]: Component };

export const initComponentMap: ComponentMap = {
  [pageComponent["component-id"]]: pageComponent,
};

export type UseComponentSearchProps = {
  searchString: string;
  setSearchString: (searchString: string) => void;
  page: Component[];
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
};
